module.exports = __webpack_public_path__ + "img/Icon material-directions-run.225ae959.svg";